export function generateComplementaryColors(primaryColor) {
  // Convert hex to RGB
  const hexToRgb = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  };

  // Convert RGB to hex
  const rgbToHex = (r, g, b) => {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  };

  // Lighten or darken a color
  const adjustColor = (color, amount) => {
    const rgb = hexToRgb(color);
    if (!rgb) return color;
    
    return rgbToHex(
      Math.min(255, Math.max(0, Math.round(rgb.r + amount))),
      Math.min(255, Math.max(0, Math.round(rgb.g + amount))),
      Math.min(255, Math.max(0, Math.round(rgb.b + amount)))
    );
  };

  // Generate complementary color (opposite on the color wheel)
  const generateComplement = (hex) => {
    const rgb = hexToRgb(hex);
    if (!rgb) return hex;
    
    // Invert the colors
    return rgbToHex(
      255 - rgb.r,
      255 - rgb.g,
      255 - rgb.b
    );
  };

  // Generate the color palette
  const primaryLight = adjustColor(primaryColor, 20);
  const primaryDark = adjustColor(primaryColor, -20);
  
  const secondaryBase = generateComplement(primaryColor);
  const secondaryLight = adjustColor(secondaryBase, 20);
  const secondaryDark = adjustColor(secondaryBase, -20);

  return {
    PRIMARY: primaryColor,
    PRIMARY_LIGHT: primaryLight,
    PRIMARY_DARK: primaryDark,
    SECONDARY: secondaryBase,
    SECONDARY_LIGHT: secondaryLight,
    SECONDARY_DARK: secondaryDark
  };
}